import React from "react";
import { Card } from "../card";
import { NotificationLists } from "./NotificationLists";

export const NotificationListsCard = () => {
  return (
    <Card cardTitle="Notifications">
      <NotificationLists />
    </Card>
  );
};
